export const setDate = (date: string) => ({
    type: 'SCHEDULE.SET_DATE',
    date: new Date(date),
});

export const generateFromDate = (firstRangeFrom, firstRangeTo) => ({
    type: 'SCHEDULE.GENERATE_FROM_DATE',
    firstRangeFrom,
    firstRangeTo,
});

export const generateToDate = (secondRangeFrom, secondRangeTo) => ({
    type: 'SCHEDULE.GENERATE_TO_DATE',
    secondRangeFrom,
    secondRangeTo,
});
